import { getPreTradeCheckerResult } from '../pre-trade-checker.routes';
import { PreTradeCheckerParams } from '../types';

export const preTradeCheckerKeys = {
  all: ['pre-trade-checker'] as const,
  check: (fundId: string, positionDate: string, isin: string) =>
    [...preTradeCheckerKeys.all, fundId, positionDate, isin] as const,
};

export const preTradeCheckerQueryOptions = ({
  fundId,
  positionDate,
  isin,
}: PreTradeCheckerParams) => ({
  queryKey: preTradeCheckerKeys.check(fundId, positionDate, isin),
  queryFn: () => getPreTradeCheckerResult({ fundId, positionDate, isin }),
  enabled: !!fundId && !!positionDate && !!isin,
  retry: false,
});
